import type { Dictionary } from 'lodash';
import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { GetShareLinkResponse } from '@backend/src/endpoints/leadGetShareLink';
import { useAppSelector } from 'store/configureStore';
import { getShareLink } from 'services/backend';

export type useLeadShareLink = UseQueryResult<GetShareLinkResponse>;

const useLeadShareLink = (): useLeadShareLink => {
  const token = useAppSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (state) => (state as Dictionary<any>).app?.token,
  );

  const activeLeadID = useAppSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (state) => (state as Dictionary<any>).app?.activeLeadID,
  );

  return useQuery({
    queryKey: ['shareLink', token, activeLeadID],
    queryFn: async () => getShareLink({ token, activeLeadID }),
    enabled: Boolean(token && activeLeadID),
    refetchOnWindowFocus: false,
    staleTime: 900000 - 1, // 15 minutes
    refetchInterval: 900000 - 1, // 15 minutes
  });
};

export default useLeadShareLink;
